import { TableColumnInfo, TableRowInfo } from "../main";
import { BaseColumnFormatter } from "./BaseColumnFormatter";

export class BaseURLImageFormatter extends BaseColumnFormatter
{
    constructor(width: string = "250px")
    {
        super();
        this.width = width;
    }
    override format(value: {
        text: any,
        image: { url: string, alt: string },
        href: string
    }, _?: TableColumnInfo, __?: TableRowInfo<any>, printable?: boolean): any
    {
        if (!printable)
        {
            return (
                <div style={{ display: "flex", alignItems: "center" }}>
                    {
                        value.image.url &&
                        <>
                            &nbsp;
                            <img src={value.image.url} alt={value.image.alt} style={{ width: "20px", height: "20px" }} />
                        </>
                    }
                    <a href={value.href} target="_blank" rel="noreferrer" style={{ width: "max-content" }}>{value.text}</a>
                </div >
            );
        }
        return value.text;
    }
}